import Vue from "vue";
import vailcode from "@utils/errcode";
export default {
  namespaced: true,
  state: {
    taskInfo: {},
  },
  mutations: {},
  actions: {
    //获取任务列表
    getTaskList: async ({ state, commit, dispatch }) => {
      return new Promise(async (resolve, reject) => {
        const res = await _v.$http.post("/task/list", {});
        console.log("resresresres", res);
        vailcode(
          res,
          () => {
            const data = res.data;
            if (!data) {
              resolve();
              return;
            }
            const tasks = {
              official: [],
              extra: [],
              onetime:[],
              daily: []
            };
            data.map((item) => {
              _v.$set(item, "isLoading", false);
              _v.$set(item, "isCancelLoading", false);
              _v.$set(item, "type", item?.provider ? item.provider : item.type);
              let target = item.target;
              try {
                if (typeof item.target === "string" && item.target != "") {
                  target = JSON.parse(item.target);
                }
              } catch (e) {}
              _v.$set(item, "target", target);
              if (item.group_type == 0) {
                tasks.extra.push(item);
              } else if(item.group_type == 1 || item.group_type == 2) {
                tasks.official.push(item);
              }else if(item.group_type== 3) {
                tasks.onetime.push(item)
              }else if(item.group_type==4) {
                tasks.daily.push(item)
              }
            });
            console.log("taskstaskstaskstasks", tasks);
            resolve(tasks);
            console.log("datadatadata", data);
          },
          () => {
            resolve();
          }
        );
      });
    },
    //验证任务
    doTask: async ({ state, commit }, params) => {
      return new Promise(async (resolve, reject) => {
        console.log("params", params);
        const res = await Vue.prototype.$http.post("/task/complete", params);
        vailcode(
          res,
          () => {
            const data = res.data;
            if (!data) {
              resolve();
              return;
            }
            resolve(data);
          },
          (err) => {
            resolve(err);
          }
        );
      });
    },
    //支付前预处理任务
    getTaskPrepare: async ({ state, commit }, params) => {
      return new Promise(async (resolve, reject) => {
        const res = await Vue.prototype.$http.post("/task/prepare", params);
        vailcode(
          res,
          () => {
            const data = res.data;
            if (!data) {
              resolve();
              return;
            }
            resolve(data);
          },
          () => {
            resolve();
          }
        );
      });
    },
    //星星支付
    openInvoiceStarPay: async (_, params) => {
      return new Promise(async (resolve) => {
        const res = await _v.WebApp.openInvoice(params.url);
        async function invoiceClosedFnc(e) {
          _v.WebApp.offEvent("invoiceClosed", invoiceClosedFnc);
          console.log("ressssssss", res, e?.status);
          if (e?.status && e.status == "paid") {
            resolve(1);
          } else if (e?.status && e.status === "cancelled") {
            resolve();
          }
        }
        _v.WebApp.onEvent("invoiceClosed", invoiceClosedFnc);
      });
    },
  },
  getters: {},
};
